import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  /** Texto principal da página - renderizado como h1 */
  title: string;
  /** Subtítulo opcional - renderizado com estilo muted */
  subtitle?: ReactNode;
  /** Conteúdo extra à direita (badges, seletores de período, etc.) */
  actions?: ReactNode;
  className?: string;
}

/**
 * Cabeçalho padronizado para páginas do painel.
 *
 * Escala fixa: título text-2xl font-display (Geist Sans Bold) +
 * subtítulo text-sm muted. Resolve inconsistência editorial entre páginas
 * que usavam text-xl/text-2xl com ou sem font-display.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  className,
}: PageHeaderProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-wrap items-start justify-between gap-x-6 gap-y-3",
        className,
      )}
    >
      <div className="space-y-1 min-w-0">
        <h1
          className={cn(
            "text-2xl font-semibold leading-tight tracking-tight text-foreground",
            "font-display",
          )}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>

      {actions && (
        <div className="shrink-0 flex items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
